export const Operations = [
    {
        key: 1,
        name: 'Mahima Bhella',
        image: require('static/team/operations/mahima-bhella.png'),
        link: '',
    }, 
    {
        key: 2,
        name: 'Amanda Chan',
        image: require('static/team/operations/amanda-chan.png'),
        link: '',
    }, 
    {
        key: 3,
        name: 'Luisa Chen',
        image: require('static/team/operations/luisa-chen.png'),
        link: '',
    }, 
    {
        key: 4,
        name: 'Krisha Chokshi',
        image: require('static/team/operations/krisha-chokshi.jpg'),
        link: '',
    }, 
    {
        key: 5,
        name: 'Rishik Durvasula',
        image: require('static/team/operations/rishik-durvasula.png'),
        link: '',
    }, 
    {
        key: 6,
        name: 'Keanu Villagonzalo',
        image: require('static/team/operations/keanu-villagonzalo.png'),
        link: '',
    }, 
    {
        key: 7,
        name: 'Sydnie Yu',
        image: require('static/team/operations/sydnie-yu.png'),
        link: '',
    }, 
];
